<template>
    <nav v-if="meta.last_page > 1" class="pagination-wrapper" aria-label="Page navigation example">
        <ul class="pagination custom-pagination">
            <template v-for="link in meta.links">
                <li
                    v-if="link.label.includes('قبلی')"
                    class="page-item custom-pagination__page-item custom-pagination__page-item-arrow"
                    :class="{'custom-pagination__page-item-arrow--disabled': !link.url}"
                >
                    <button class="page-link custom-pagination__page-link" @click="goPrev">
                        <span class="icon-Chevron_right"></span>
                    </button>
                </li>
                <li
                    v-else-if="link.label.includes('بعدی')"
                    class="page-item custom-pagination__page-item custom-pagination__page-item-arrow"
                    :class="{'custom-pagination__page-item-arrow--disabled': !link.url}"
                >
                    <button class="page-link custom-pagination__page-link" @click="goNext">
                        <span class="icon-Chevron_left"></span>
                    </button>
                </li>
                <li
                    v-else
                    class="page-item"
                    :class="{'custom-pagination__page-item--active': link.active}"
                >
                    <button class="page-link custom-pagination__page-link" @click="() => goToPage(Number(link.label))">
                        <span>{{link.label}}</span>
                    </button>
                </li>
            </template>
        </ul>
    </nav>
</template>

<script>
export default {
    name: "Pagination",
    methods: {
        goNext() {
            if (this.meta.current_page !== this.meta.last_page) {
                this.$store.commit('archive/setPage', this.meta.current_page-1);
                this.$store.commit('archive/fireTrigger');
            }
        },
        goPrev() {
            if (this.meta.current_page !== 1) {
                this.$store.commit('archive/setPage', this.meta.current_page+1);
                this.$store.commit('archive/fireTrigger');
            }
        },
        goToPage(page) {
            if (this.meta.current_page !== page) {
                this.$store.commit('archive/setPage', page);
                this.$store.commit('archive/fireTrigger');
            }
        }
    },
    computed: {
        meta() {
            return this.$store.state.archive.meta;
        },
    },
}
</script>

<style scoped>

</style>
